import Notes from './components/Notes'

import {GlobalStyle} from './styledComponents'

const App = () => (
  <>
    <GlobalStyle />
    <Notes />
  </>
)

export default App
